export default {
  workingTime: {
    workingTime: "Working Time",
    dateTime: "Date/Time",
    clockInTime: "Clock In Time",
    clockOutTime: "Clock Out Time",
    clockInType: "Clock In Type",
    clockOutType: "Clock Out Type",
    all: "All",
    auto: "Auto",
    AUTO: "Auto",
    manual: "Manual",
    MANUAL: "Manual",
    forceClockOut: "Force Clock out",
    FORCE_CLOCK_OUT: "Force Clock out",
    filter: "Filter",
    resetFilter: "Reset filter",
    noData: "No Data",
    driver: "Driver",
    recordNo: "Record No.",
    workingHour: "Working Hours",
    clockInLocation: "Clock In Location",
    clockInLatLng: "Clock In (Actual lat,lng)",
    clockOutLocation: "Clock Out Location",
    clockOutLatLng: "Clock Out (Actual lat,lng)",
    search: "Search...",
    driverName: "Driver Name",
    driverId: "Driver ID",
    hrs: "Hrs",
    mins: "Mins",
    latitude: "Latitude",
    longitude: "Longitude",
    null: "",
  },
};



// WEBPACK FOOTER //
// ./src/lang/en/pages/workingTime/workingTime.js